module.exports = __webpack_public_path__ + "img/room-continuation.1f243ce.svg";